module.exports = __webpack_public_path__ + "img/illustration_01.47fa2941.png";